import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="globalmainstyles">
      <h1>Terms and Conditions</h1>
      <p>Welcome to Hjem Properties!</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using this app, you agree to comply with and be bound by these Terms
        and Conditions. If you do not agree with any part of these terms, you
        should not use the app.
      </p>

      <h2>2. Rental Services</h2>
      <p>
        Hjem Properties facilitates the rental of various properties between
        users. We do not own, rent, or control any of the properties listed on
        the platform. We are not responsible for the quality, safety, or
        legality of the properties. Users are solely responsible for their
        transactions.
      </p>

      <h2>3. User Conduct</h2>
      <p>
        Users must be at least 18 years old to use the app. You agree not to use
        the app for any illegal or unauthorized purpose. You are responsible for
        all content you post and must not violate any third-party rights or our
        policies.
      </p>

      <h2>4. Fees and Payments</h2>
      <p>
        Hjem Properties may charge fees for using the platform. Fees and payment
        terms will be clearly specified. Users are responsible for all
        applicable taxes.
      </p>

      <h2>5. Privacy</h2>
      <p>
        We collect and process user data according to our Privacy Policy. By
        using the app, you consent to our data practices as described in the
        Privacy Policy.
      </p>

      <h2>6. Disclaimer of Warranties</h2>
      <p>
        Hjem Properties is provided "as is" without any warranty or guarantee.
        We do not guarantee the accuracy, availability, or reliability of the
        app or its content. Users use the app at their own risk.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        Hjem Properties shall not be liable for any direct, indirect,
        incidental, special, consequential, or exemplary damages resulting from
        the use or inability to use the app.
      </p>

      <h2>8. Modifications</h2>
      <p>
        Hjem Properties reserves the right to modify or update these Terms and
        Conditions at any time. Changes will be effective upon posting on the
        app. It is your responsibility to review the Terms regularly.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may terminate or suspend your account and access to the app at any
        time, with or without cause, and without prior notice.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These Terms and Conditions shall be governed by and construed in
        accordance with the laws of [Your Country/State].
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions or concerns about these Terms and Conditions,
        please contact us at [Your Email Address].
      </p>
    </div>
  );
};

export default TermsAndConditions;
